var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuildings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.018 15.748h-1.5a.75.75 0 000 1.5h1.5a.75.75 0 100-1.5zM18.018 13.498h-1.5a.75.75 0 110-1.5h1.5a.75.75 0 010 1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M22.518 19.498h-.75v-9.75a1.501 1.501 0 00-1.5-1.5h-6v-4.5a1.501 1.501 0 00-1.5-1.5h-9a1.502 1.502 0 00-1.5 1.5v15.75h-.75a.75.75 0 000 1.5h21a.75.75 0 000-1.5zm-11.25-6.75a.75.75 0 01-.75.75h-3a.75.75 0 110-1.5h3a.75.75 0 01.75.75zm-5.25-6.75h3a.75.75 0 010 1.5h-3a.75.75 0 110-1.5zm3 9.75a.75.75 0 010 1.5h-3a.75.75 0 110-1.5zm5.25-6h6v9.75h-6z",
    fillRule: "evenodd"
  }))));
}

export default SvgBuildings;